module.exports = __webpack_public_path__ + "img/hr-pumpjack-base.303da5a4.png";